module.exports = __webpack_public_path__ + "static/media/sun.1ed7b9b7.svg";